import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { updateRecord } from "../../../../features/crm/activities/activitiesSlice";
import AddEntityForm from "../../../templates/AddEntityForm";
import { getFormItems } from "./FormItemsConfig";
import { actionTypes } from "../../constants";
import { useActivity } from "../../hooks/useActivity";

const EditActivity = (props) => {
  const {
    entity,
    entityId,
    branchId,
    recordId,
    hide,
    record,
    visible,
    type,
    onReloadFeed,
  } = props;
  const [activeEntity, setActiveEntity] = useState();
  const {
    disabledStartDate,
    disabledEndDate,
    disabledStartHours,
    disabledStartMinutes,
    disabledEndHours,
    disabledEndMinutes,
  } = useActivity(activeEntity);

  const intl = useIntl();
  const dispatch = useDispatch();
  const createLoading = useSelector(
    (state) => state.pendingActions["patientAbsences/create"]
  );
  const updateLoading = useSelector(
    (state) => state.pendingActions["patientAbsences/update"]
  );
  const scopePrefix = useSelector((state) => state.user.scopePrefix);

  useEffect(() => {
    setActiveEntity(record);
  }, [record]);

  const onFinish = useCallback(
    async (values) => {
      const activityType = type === "event" ? "events" : "tasks";
      const params = {
        activity: { ...values, id: recordId },
        activityType,
        entity,
        entityId,
        scope: `branches/${branchId}`,
      };
      const action = await dispatch(updateRecord(params));
      if (!action.error) {
        onReloadFeed();
        hide();
      }
    },
    [dispatch, type, recordId, entity, entityId, branchId, onReloadFeed, hide]
  );

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onDecline = () => {
    hide();
  };

  const onValuesChange = useCallback((values) => {
    setActiveEntity(values);
  }, []);

  const items = useMemo(
    () =>
      getFormItems(type, {
        scopePrefix,
        disabledStartDate,
        disabledStartHours,
        disabledStartMinutes,
        disabledEndDate,
        disabledEndHours,
        disabledEndMinutes,
        activeEntity,
        entity,
      }),
    [type, scopePrefix, activeEntity]
  );
  return (
    <AddEntityForm
      formLayout={{
        labelCol: { span: 7 },
        wrapperCol: { span: 17 },
      }}
      style={{ padding: 0 }}
      resource={actionTypes.PATIENTS}
      action={actionTypes.EDITOR}
      activeEntity={activeEntity}
      items={items}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      onEntityValuesChange={onValuesChange}
      onDecline={onDecline}
      saveLoading={createLoading || updateLoading}
      addText={intl.formatMessage({
        id:
          type === "call"
            ? actionTypes.ACTIVITIES_EDIT_LOG
            : type === "task"
            ? actionTypes.ACTIVITIES_EDIT_TASK
            : actionTypes.ACTIVITIES_EDIT_EVENT,
      })}
      mode={"edit"}
    />
  );
};

export default EditActivity;
